// @ts-nocheck
// this will generate the average and medain tab items inside the salary page
import { currencyFormatter } from "@sia/style-guide";
export function generateNavigationItems(translate, setSelectedItem) {
  const navigationItems = [
    {
      label: translate("benchmarking.evaluations.salary.content-nav.average"),
      onClick: () => {
        setSelectedItem(0);
      },
    },
    {
      label: translate("benchmarking.evaluations.salary.content-nav.median"),
      onClick: () => {
        setSelectedItem(1);
      },
    },
  ];
  return navigationItems;
}

function tooltipNumberFormmater(value, label) {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number") {
    let temp = value.toFixed(2);
    temp = Number.parseFloat(temp);
    return currencyFormatter.formatAlternate(temp, "CHF");
  }
}

// this will generate the Barchart option props
export function generateBarchartOptions(translate, isMobile) {
  const ownValueColorCode = "#e41a11";
  const averageColorCode = "#000000";

  let options = {
    color: {
      scale: {
        [translate("benchmarking.evaluations.salary.chart-legend.my-office")]: ownValueColorCode,
        [translate("benchmarking.evaluations.salary.chart-legend.average")]: averageColorCode,
      },
    },
    legend: {
      order: [translate("benchmarking.evaluations.salary.chart-legend.average"), translate("benchmarking.evaluations.salary.chart-legend.my-office")],
    },
    axes: {
      left: {
        truncation: {
          threshold: isMobile ? 10 : 50,
          numCharacter: isMobile ? 10 : 50,
        },
      },
    },
    tooltip: {
      valueFormatter: tooltipNumberFormmater,
    },
  };
  return options;
}

// get the legends name and color
export function getBoxplotLegends(translate, isMasterKeyValid) {
  const ownValueColorCode = "#e41a11";
  const averageColorCode = "#000000";
  let legends = [{ name: translate("benchmarking.evaluations.salary.chart-legend.average"), color: averageColorCode }];
  if (isMasterKeyValid) {
    let ownValueLegend = { name: translate("benchmarking.evaluations.salary.chart-legend.my-office"), color: ownValueColorCode };
    legends.push(ownValueLegend);
  }
  return legends;
}

// this will generate the BoxPlot option props
export function generateBoxPlotOptions(translate, isMobile) {
  const ownValueColorCode = "#e41a11";
  const averageColorCode = "#000000";

  let options = {
    color: {
      scale: {
        [translate("benchmarking.evaluations.salary.chart-legend.my-office")]: ownValueColorCode,
        [translate("benchmarking.evaluations.salary.chart-legend.average")]: averageColorCode,
      },
    },
    legend: {
      order: [translate("benchmarking.evaluations.salary.chart-legend.average"), translate("benchmarking.evaluations.salary.chart-legend.my-office")],
    },
    axes: {
      left: {
        truncation: {
          threshold: isMobile ? 10 : 50,
          numCharacter: isMobile ? 10 : 50,
        },
      },
    },
    tooltip: {
      valueFormatter: tooltipNumberFormmater,
    },
  };
  return options;
}

// Salary page table headers
export function generateHeaderRows(translate, headerRowGenerator, isMasterKeyValid) {
  if (headerRowGenerator) {
    return headerRowGenerator();
  }
  let headerLabelKeys = ["function", "numberOfEmployee", "dataQuality", "baseSalary", "additional", "variable", "grossSalary"];
  let headerRows = [];
  let extraClasses = !isMasterKeyValid ? " without-own-value" : "";
  let firstHeaderRow = {
    className: "main-header",
    headers: headerLabelKeys.map((key, index) => {
      let baseObject = {
        id: key,
        key: key,
        colSpan: isMasterKeyValid ? 3 : 1,
        name: translate(`benchmarking.data-table.header-row.${key}`),
        className: "bold-header no-border".concat(extraClasses),
      };
      if (index === 0) {
        return {
          ...baseObject,
          colSpan: 1,
          rowSpan: 2,
          className: "no-border",
        };
      }
      if (index === 1) {
        return {
          ...baseObject,
          colSpan: 1,
          rowSpan: 2,
          className: "no-border number-of-employees",
        };
      }
      if (index === 2) {
        return {
          id: key,
          key: key,
          name: "",
          colSpan: 1,
          rowSpan: 2,
          className: "no-border data-quality-header",
        };
      }

      return baseObject;
    }),
  };
  headerRows.push(firstHeaderRow);
  let subheaderLabelKeys = ["baseSalary", "additional", "variable", "grossSalary"];
  let secondHeaderRow = {
    className: "secondary-header",
    headers: [],
  };
  subheaderLabelKeys.forEach((key, index) => {
    let subheaders = [
      {
        headers: key,
        key: `average${key}`,
        name: translate("benchmarking.data-table.header-row.average"),
        className: "no-right-padding".concat(extraClasses),
      },
      {
        headers: key,
        key: `ownValue${key}`,
        name: translate("benchmarking.data-table.header-row.ownValue"),
        className: "middle-col",
      },
      {
        headers: key,
        key: `delta${key}`,
        name: translate("benchmarking.data-table.header-row.delta"),
        className: "no-left-padding",
      },
    ];
    if (isMasterKeyValid) {
      secondHeaderRow.headers.push(...subheaders);
    } else {
      secondHeaderRow.headers.push(subheaders[0]);
    }
  });
  headerRows.push(secondHeaderRow);
  return headerRows;
}

// Salary page boxplot table header
export function generateBoxplotTableHeader(translate, isMasterKeyValid) {
  let headerRows = [
    {
      className: "main-header",
      headers: [
        {
          id: "function",
          key: "function",
          name: translate("benchmarking.evaluations.salary.boxplot-table.function"),
          className: "bold-header no-border left-align",
          rowSpan: 2,
        },
        {
          id: "numberOfEmployee",
          key: "numberOfEmployee",
          name: translate("benchmarking.evaluations.salary.boxplot-table.numberOfEmployee"),
          className: "bold-header no-border",
          rowSpan: 2,
        },
        {
          id: "dataQuality",
          key: "dataQuality",
          name: "    ",
          className: "no-border data-quality-header",
          rowSpan: 2,
        },
        {
          id: "grossSalary",
          key: "grossSalary",
          name: translate("benchmarking.evaluations.salary.boxplot-table.grossSalary"),
          className: "bold-header no-border",
          colSpan: 3,
        },
      ],
    },
    {
      className: "secondary-header",
      headers: [
        {
          headers: "grossSalary",
          key: "p25",
          name: translate("benchmarking.evaluations.salary.boxplot-table.grossSalary.p25"),
          className: "bold-header no-border",
        },
        {
          headers: "grossSalary",
          key: "average",
          name: translate("benchmarking.evaluations.salary.boxplot-table.grossSalary.average"),
          className: "bold-header no-border",
        },
        {
          headers: "grossSalary",
          key: "p75",
          name: translate("benchmarking.evaluations.salary.boxplot-table.grossSalary.p75"),
          className: "bold-header no-border",
        },
      ],
    },
  ];
  if (isMasterKeyValid) {
    headerRows[0].headers.push({
      id: "grossSalaryOwnValue",
      key: "grossSalaryOwnValue",
      name: translate("benchmarking.evaluations.salary.boxplot-table.grossSalary.ownValue"),
      className: "bold-header no-border",
      colSpan: 1,
    });
    headerRows[1].headers.push({
      headers: "grossSalaryOwnValue",
      key: "median",
      name: translate("benchmarking.evaluations.salary.boxplot-table.grossSalary.ownValue.average"),
      className: "bold-header no-border median",
    });
  }
  return headerRows;
}
